import { render } from "./FixedLineOptimizationDetail.vue?vue&type=template&id=55f7bd68&scoped=true"
import script from "./FixedLineOptimizationDetail.vue?vue&type=script&lang=js"
export * from "./FixedLineOptimizationDetail.vue?vue&type=script&lang=js"

import "./FixedLineOptimizationDetail.vue?vue&type=style&index=0&id=55f7bd68&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./FixedLineOptimizationDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7bd68"]])

export default __exports__